import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftSecretServer } from "namirasoft-secret";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import SecretEditPage from "./pages/SecretEditPage";
import SecretListPage from "./pages/SecretListPage";
import SecretViewPage from "./pages/SecretViewPage";
import { SecretLayout } from "./SecretLayout";
import { SecretRoutes } from "./SecretRoutes";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_SECRET}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_SECRET = new EnvService("REACT_APP_BASE_URL_SECRET", true).getString();

            let secret = new NamirasoftSecretServer(REACT_APP_BASE_URL_SECRET, result.account.token_manager, result.notifier.onError);

            let servers = { secret };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={SecretRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={SecretRoutes.SecretList} element={<SecretListPage {...result} servers={servers} />} />
                            <Route path={SecretRoutes.SecretNew} element={<SecretEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={SecretRoutes.SecretView(":id")} element={<SecretViewPage {...result} servers={servers} />} />
                            <Route path={SecretRoutes.SecretEdit(":id")} element={<SecretEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={SecretRoutes.SecretCopy(":id")} element={<SecretEditPage {...result} servers={servers} isEdit={false} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={SecretRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <SecretLayout {...props}>
                {props.children}
            </SecretLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;